///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.proof_of_performance = abcsetup.promos.proof_of_performance || {};
abcsetup.promos.proof_of_performance.promo_type = abcsetup.promos.proof_of_performance.promo_type || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.proof_of_performance.promo_type = {
    init: function() {
        // abcsetup.fieldLib.init();
        abcsetup.setTitle('Proof Of Performance');
        var init_proof_of_performance_acl_listeners = true;
        // Workflow history modal shown
        $('#proof_of_performance_acl').on('show.bs.modal', function (e) {
            var search_checkboxs = true;
            var attachment = null

            $(this).find('.modal-body').html('<center>Loading Proof Of Performance</center>');
            if($('input#attachement_id').val()) {
                search_checkboxs =false;
                attachment = $('input#attachement_id').val();
                $('input#attachement_id').val('');
            }
            abcsetup.promos.proof_of_performance.promo_type.access_control_list($(this),search_checkboxs,attachment);

            if (init_proof_of_performance_acl_listeners) {
                $('#proof_of_performance_acl').on('click',"#share_attachment",function() {
                    var fields = $('form#promo_perf_library_acl').serialize();
                    axios.post('/api/proof_of_performance/access_control_list_alt',fields).then(response => { 
                        if (response.data.error) {
                            abcsetup.alerts.show('Error', response.data.error);
                            console.log("ERROR: Promo Perf_library Acl[update]: "+response.data.error);
                        } else {
                            $('#proof_of_performance_acl').modal('hide');
                            abcsetup.alerts.show('Success', 'Proof Of Performance updated successfully');
                        }
                    }).catch(error => {
                        abcsetup.alerts.show('Error', error.response.data.error);
                        console.log("ERROR: page_blocks[save]: "+error.response.data.error);
                    });
                });
                init_proof_of_performance_acl_listeners = false;
            }
        })
        
        var id = $('#promo_id').val();
        var promo_type = $('#promo_type').val();
        var ajax = "/api/proof_of_performance/datatable";
        
        if (id) {
            ajax = "/api/proof_of_performance/datatable/"+id;
        }

        if (promo_type) {
            ajax += '?promo_type='+promo_type;
        }

        console.log('ajax -> '+ajax); 

        datatable = abcsetup.datatables.init($('table#proof_of_performance'), {
            bInfo: true,
            scroll_horizontal: true,
            "responsive": false,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "iDisplayLength": 25,
            stateSave:false,
            /*
            "columnDefs": [{
                "targets": [34],
                "orderable": false
            }],
            */
            "order": [[1, "asc"]],
            serverSide: true,
            "colReorder": false,
            //processing: true,
            ajax: ajax,
            columns: [
                { name: 'action', orderable: false, searchable: false},
                { name: 'filename' },
                { name: 'user_name'},
                { name: 'promo_name'},
                { name: 'type_name'},
                { name: 'fiscal_year'},
                { name: 'start_run'},
                { name: 'end_run'},
                { name: 'size_mb', orderable: false, searchable: false},
                { name: 'create_date'},
            ],
        });

        abcsetup.promos.proof_of_performance.promo_type.datatable = datatable;

        $(document).on('click', '.btn.btn-remove-proof_of_performance', function (e) {
            var proof_of_performance_id = $(this).attr('data-id');
            var proof_of_performance_filename = $(this).attr('data-filename'); 
            abcsetup.alerts.confirm('Delete Proof Of Performance', 'Are you sure you want to remove attachment : '+proof_of_performance_filename+' ?', function (resp) {
                if (resp) {
                    abcsetup.blockUI(true);
                    abcsetup.promos.proof_of_performance.promo_type.delete(proof_of_performance_id);
                    abcsetup.unblockUI();
                }
            });
        });

        $(document).on('click','.promo_perf_library_edit_button', function () {
            var id = $(this).attr('data-id');
            $('input.promo_proof_perf_library_attachment_checkbox').prop("checked",false);
            $(`input.promo_proof_perf_library_attachment_checkbox[data-id="${id}"]`).prop("checked",true);
            $('input#attachement_id').val(id);
            $('#proof_of_performance_acl').modal('toggle');
        });

        $(document).on('click','#proof_of_performance_delete', function() {
            abcsetup.alerts.confirm('Delete Proof Of Performance', 'Are you sure you want to delete the checked attachments ?', function (resp) {
                if (resp) {
                    $( ".promo_proof_perf_library_attachment_checkbox" ).each(function() {
                        if ($(this).is(":checked")) {
                            abcsetup.blockUI(true);
                            abcsetup.promos.proof_of_performance.promo_type.delete($(this).data("id")); 
                            abcsetup.unblockUI();
                        }
                    });
                }
            });
        })

        $(document).on('click','.promo_proof_perf_library_attachment_checkbox', function () {
            var numberOfChecked = $('input.promo_proof_perf_library_attachment_checkbox:checked').length;
            if (numberOfChecked == 0) {
                $('.proof_of_performance_buttons button').prop( "disabled", true);
            } else {
                $('.proof_of_performance_buttons button').prop( "disabled", false);
            }
        });

        $('.proof_of_performance_buttons button').prop( "disabled", true);
    },
    /**
     *
     * @param {*} id
     */
    delete: function(id) {
        axios.delete('/proof_of_performance/' + id).then(response => {
            abcsetup.promos.proof_of_performance.promo_type.datatable.ajax.reload();
        });
    },
    /**
     *
     */
    access_control_list: function(_this,search_checkboxs=true,attachment=null) {
        // alert(1);
        var promo_perf_library_id = [] ;

        if (search_checkboxs) {
            $( ".promo_proof_perf_library_attachment_checkbox" ).each(function() {
                if ($(this).is(":checked")) {
                   promo_perf_library_id.push($(this).data("id")); 
                }
             });
        } else if(!search_checkboxs && attachment.length) {
            promo_perf_library_id = attachment;
        }


        if (promo_perf_library_id.length) {
            axios.get('/api/proof_of_performance/proof_of_performance_acl',{
                params: {promo_perf_library_id : promo_perf_library_id}
            }).then(response => {
                _this.find('.modal-body').html(response.data);
                _this.find('.datatable').show();
                // For the shuttle box. 
                abcsetup.fieldLib.init();
                var participated_suppliers = JSON.parse($('.participated_suppliers').text());
                
                if (participated_suppliers) {
                    var shuttlebox_left = $('input[name="suppliers_participated"]').closest('.shuttlebox').find('.shuttlebox-left select');
                    for (var supplier of participated_suppliers) {
                        shuttlebox_left.append('<option value="'+supplier['id']+'">'+supplier['name']+'</option>');
                    }
                }

                var promo_perf_library_acl_field_data = JSON.parse($('.promo_perf_library_acl_field_data').text());
                var suppliers_participated = [];
                var numberOfChecked = $('input.promo_proof_perf_library_attachment_checkbox:checked').length;

                if (numberOfChecked == 0 || numberOfChecked == 1) {
                    for (var index in promo_perf_library_acl_field_data) {
                        //Check, vendor.
                        if (promo_perf_library_acl_field_data[index].org_class == 'vendor') {
                            $('input[name=vendor]').prop("checked",true);
                        }
                        //Check, Category manager.
                        if (promo_perf_library_acl_field_data[index].role_class == 'fs_cm') {
                            $('input[name=fs_cm]').prop("checked",true);
                        }
                        //Check, Directors.
                        if (promo_perf_library_acl_field_data[index].role_class == 'director') {
                            $('input[name=director]').prop("checked",true);
                        }
    
                        // Populate Shuttlebox
                        if (promo_perf_library_acl_field_data[index].org) {
                            suppliers_participated.push(promo_perf_library_acl_field_data[index].org);
                        }
                    }
                }

                abcsetup.form_manager.form = $('form#promo_perf_library_acl');
                abcsetup.form_manager._setFieldValue('suppliers_participated',suppliers_participated);
            });
        }
    },
}